"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reduxOidc = require("redux-oidc");

var _OidcUserManager = require("../../services/OidcUserManager");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CallbackPage = function CallbackPage(props) {
  return _react2.default.createElement(
    _reduxOidc.CallbackComponent,
    {
      userManager: (0, _OidcUserManager.userManager)(),
      successCallback: props.onSuccess,
      errorCallback: props.onError },
    props.loadingComponent || _react2.default.createElement("div", null)
  );
};

exports.default = CallbackPage;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/components/oidc/CallbackPage.js
// module id = 751
// module chunks = 10